export default {
  addShopSuccess: 'Article ajouté avec succès',
  addShopFail: "Échec de l'ajout de l'article",
  getCartDataFail: 'Échec de la récupération des articles du panier',
  hint: 'Conseil',
  delConfirmProduct: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  productInfo: 'Détails du produit',
  unitPrice: 'Prix unitaire',
  num: 'Qté',
  subtotal: 'Sous-total',
  action: 'Action',
  productName: 'Nom du produit',
  splitProduct: 'Diviser le produit',
  split: 'Diviser',
  allSelect: 'Tout sélectionner',
  delProduct: 'Supprimer la sélection',
  selected: 'Sélectionné',
  piece: 'Article(s)',
  total: 'Total',
  productTotal: 'Hors frais de livraison internationale',
  orderPay: 'Passer à la caisse',
  orderTotal: 'Total de la commande',
  goCartPay: 'Voir le panier',
  moreView: "Plus d'articles dans le panier",
  noSelectText: "Vous n'avez sélectionné aucun produit pour le moment",
  paySuccess: 'Paiement réussi !',
  returnPayment: 'Retourner pour continuer le paiement',
  service: 'Service',
  goodsMinNumErrTips:
    "Ce produit nécessite une quantité d'achat minimum de {num}, vous pouvez choisir différentes spécifications selon vos besoins.",
  balckShop: 'La boutique est sur liste noire',
  forbidBuy: 'Boutique à risque, achat interdit',
  riskTip: 'Boutiques à risque, veuillez acheter avec prudence',
  riskReminder: 'Rappel de risque',
  blackenedShop: 'Boutique mise sur liste noire',
  riskProducts: 'Produits à risque',
  riskMsg1:
    "Il peut y avoir un certain risque associé aux produits que vous soumettez. Pour votre sécurité financière, nous ne sommes pas en mesure de vous fournir des services de commande en ligne pour le moment. Pour plus d'informations, veuillez contacter le service client ou l'achat spécialisé.",
  riskMsg2:
    "Les produits que vous soumettez peuvent présenter un certain risque d'expédition. Pour votre sécurité financière, nous ne sommes temporairement pas en mesure de vous fournir des services de commande en ligne. Pour plus d'informations, veuillez contacter le service client en ligne !",
  riskMsg3:
    "Le produit que vous achetez peut être un article spécialisé ou de marque. Nous n'avons pas la capacité d'authentifier son authenticité et ne pouvons offrir que des services d'approvisionnement et d'inspection de qualité de base. Tous les risques potentiels doivent être assumés par vous.",
  continueToBuy: "Continuer à acheter d'autres articles",
  buyOthers: "Acheter d'autres articles",
  continuePurchasing: 'Continuer les achats',
}
